module.exports = __webpack_public_path__ + "static/media/Group_1597880740@2x(1).ae1479b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_136/imgs/Group_1597880740@2x(1).png
// module id = 1212
// module chunks = 0